import { render, staticRenderFns } from "./FilterSummaryItemHeron.vue?vue&type=template&id=16892ee6&"
import script from "./FilterSummaryItemHeron.vue?vue&type=script&lang=js&"
export * from "./FilterSummaryItemHeron.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports